import { withTheme } from "@emotion/react";
import CITFormGroup from "../../../../Form/CITFormGroup";
import DateInput from "../../../../Form/DateInput";
import { Typography, Box, Stack, Divider, FormControlLabel, Checkbox, Grid,FormHelperText } from "@mui/material";
import SelectInput from "../../../../Form/SelectInput";
import RadioButtonsGroup from "../../../../Form/RadioButtonsGroup";
import TextInput from "../../../../Form/TextInput";
import FileInput from "../../../../Form/FileInput";



const EmploymentInfo = (props) => {


    const postions = []
    const employments = ['Full-time', 'Part-time', 'Per-diem', 'Contract']
    const answers = ['Yes', 'No']
    const certifiations = ['ACLS', 'BCLS', 'PALS', 'IV', 'NALS', 'Other']

    const theme = props.theme

    const Header = (props) => {

        return (<Box mt={props.mt ?? 0} width={'100%'}>
            <Stack direction={'column'}>
                <Typography mb={'8px'} color={'#292727'} lineHeight={'normal'} fontWeight={700} fontStyle={'normal'} fontFamily={'Inter'} fontSize={'16px'}>{props.title}</Typography>
                <Divider />
            </Stack>
        </Box>
        )
    }

    const Certifications = () => {

        return (

            <Box mt={'16px !important'} width={'100%'}>
                 <FormHelperText sx={{...theme.typography.inputTitle, color:'#292727', mb:'16px'}} id="my-helper-text">{'Check all applicable certifications and enter expiration date'}</FormHelperText>
                <Grid container rowSpacing={'16px'} columnSpacing={'48px'} >
                    {certifiations.map((cert) => (
                        <Grid key={cert} item xs={12} sm={6}>
                            <Stack alignItems={'center'} direction={'row'}>
                                <FormControlLabel sx={{ width: cert ==='IV'? '100px':'auto'}} control={<Checkbox  />} label={<Typography color='#292727' lineHeight={'normal'} fontStyle={'normal'} fontWeight={400} fontSize={'14px'} fontFamily={'inter'}>{cert}</Typography>} />
                                <DateInput boxWidth={'100%'} inputWidth={'inherit'} />
                            </Stack>
                        </Grid>
                    ))
                    }
                </Grid>
            </Box>
        )
    }

    return (

        <Box width={'inherit'}>
            <Stack mx={{ xs: '19px', sm: '60px', md: '85px' }} justifyContent={'space-around'} mt={'24px'} >
                <Typography width={{sm:'668px',md:'998px'}} mb={'24px'} mt={'48px'} sx={{ ...theme.typography.heading, fontSize: { xs: '18px', sm: '20px', md: '29px' } }} gutterBottom>
                    {'EMPLOYMENT INFORMATION'}
                </Typography>
            </Stack>

            <CITFormGroup mt={'0px'} direction={'column'}>
                <DateInput boxWidth={'100%'} inputWidth={'inherit'} dateLable={'Application date'} />
                 <SelectInput mt='24px' label={'Position applying for'} inputWidth={'100ch'} options={postions} />
                <RadioButtonsGroup  label={'Employment type'} options={employments} /> 
                <TextInput mt='24px' textLable={'Name (Last, first, middle)'} placeholder={'Your name'} boxWidth={'100%'} inputWidth={'inherit'} />
                <TextInput mt='24px' textLable={'Social Security Number (SSN)'} placeholder={'Your ssn'} boxWidth={'100%'} inputWidth={'inherit'} />
                <CITFormGroup mt={'24px'} mx={'0px'} width={'100%'}>
                    <TextInput textLable={'City'} placeholder={'City'} boxWidth={'100%'} inputWidth={'inherit'} />
                    <TextInput textLable={'State'} placeholder={'State'} boxWidth={'100%'} inputWidth={'inherit'} />
                    <TextInput textLable={'Zip Code'} placeholder={'Zip code'} boxWidth={'100%'} inputWidth={'inherit'} />
                </CITFormGroup>
                <TextInput textLable={'Phone'} placeholder={'Phone number'} boxWidth={'100%'} inputWidth={'inherit'} />
                <TextInput textLable={'Email address'} placeholder={'Email'} boxWidth={'100%'} inputWidth={'inherit'} />
                <TextInput textLable={'Home address'} placeholder={'Home address'} boxWidth={'100%'} inputWidth={'inherit'} />
                <Header title="License" />
                <TextInput mt="16px !important" textLable={'License type'} placeholder={'License type'} boxWidth={'100%'} inputWidth={'inherit'} />
                <TextInput textLable={'License/Certification#'} placeholder={'License/Certification#'} boxWidth={'100%'} inputWidth={'inherit'} />
                <CITFormGroup mt={'24px'} mx={'0px'} width={'100%'}>
                    <TextInput textLable={'State'} placeholder={'State'} boxWidth={'100%'} inputWidth={'inherit'} />
                    <TextInput textLable={'Expiration Date'} placeholder={'Expiration Date'} boxWidth={'100%'} inputWidth={'inherit'} />
                </CITFormGroup>
                <FileInput title="Add license" />
                <RadioButtonsGroup  label={'Have your license ever been suspended, revoked, or under investigation? '} options={answers} />
                <TextInput textLable={'If Yes, please explain:'} placeholder={'Your response'} boxWidth={'100%'} inputWidth={'inherit'} />
                <Header mt={'48px !important'} title="Certifications" />
                <Certifications />

            </CITFormGroup>

        </Box>



    )
}

export default withTheme(EmploymentInfo);